import React, { useState } from 'react';
import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './SideFilter.module.scss';
import { joinClasses } from '../../Utils/className.util';

interface SideFilter {
	children?: React.ReactElement | React.ReactElement[];
	style?: object;
	className?: any;
	isOpenByDefault?: boolean;
}

export default function SideFilter(props: SideFilter) {
	const { children, className, style, isOpenByDefault = true } = props;
	const [showFilter, setShowFilter] = useState(isOpenByDefault);

	const handleToggle = () => {
		setShowFilter(prev => !prev);
	};

	return (
		<div
			className={joinClasses([
				className,
				styles.wrapper,
				!showFilter && styles.closed,
			])}
			style={style}>
			<div
				className={showFilter ? styles.arrowClose : styles.arrowOpen}
				onClick={handleToggle}>
				{!showFilter && (
					<Text
						className={styles.filterTitle}
						tx={'base.shared.filtering'}
						firstUpper={true}
					/>
				)}
			</div>
			{showFilter && children}
		</div>
	);
}
